export const endpoints = {
  subscriberGroupOptions: 'subscriberGroup/options',
  userMemberSearch: 'subscriberGroup/userMember/search',
  saveActions: (id: number) => `subscriberGroup/${id}:link`
};
